"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isZeroOrPositive;

function isZeroOrPositive(value) {
  // This will handle minus-zero.
  return 1 / value >= 0;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9VdGlscy9pc1plcm9PclBvc2l0aXZlLmpzIl0sIm5hbWVzIjpbImlzWmVyb09yUG9zaXRpdmUiLCJ2YWx1ZSJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLGdCQUFULENBQTBCQyxLQUExQixFQUFpQztBQUM5QztBQUNBLFNBQU8sSUFBSUEsS0FBSixJQUFhLENBQXBCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGlzWmVyb09yUG9zaXRpdmUodmFsdWUpIHtcbiAgLy8gVGhpcyB3aWxsIGhhbmRsZSBtaW51cy16ZXJvLlxuICByZXR1cm4gMSAvIHZhbHVlID49IDA7XG59XG4iXX0=